import { Component, inject, OnInit } from '@angular/core';
import { CommonConfirmActionService } from '@app/services/common-confirm-action.service';
import { isJedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import { Item, ItemActionResult, ItemViewProviderDirective } from '@ntap/core';
import { map, Observable, of, switchMap } from 'rxjs';
import { ActionServerCloseActionComponent } from '../action-server-close-action/action-server-close-action.component';
import { withTooltipState } from '@app/shared/mixins/with-tooltip-state.mixin';

@Component({
  selector: 'app-objava-odobjava-jedinice',
  templateUrl: '../common-confirm-action-template.html'
})
export class ObjavaOdobjavaJediniceComponent
  extends withTooltipState(ActionServerCloseActionComponent)
  implements OnInit
{
  private itemViewProvider = inject(ItemViewProviderDirective);
  public commonConfirmActionService = inject(CommonConfirmActionService);

  label$: Observable<string>;

  key: string = 'objavaOdobjava' + this.toString;

  public override doExecuteWithItem(item: Item): Observable<ItemActionResult> {
    return this.commonConfirmActionService.confirm(this.key).pipe(
      switchMap(({ confirmed, addPodjedinice }) => {
        if (confirmed) {
          const updatedItem = {
            ...item,
            $addPodjedinice: addPodjedinice
          };
          return super.doExecuteWithItem(updatedItem);
        }
        return of();
      })
    );
  }

  ngOnInit(): void {
    this.label$ = this.itemViewProvider.item$.pipe(
      map((item) => {
        let label = 'Objavi';
        let newTooltip: string | undefined = undefined;

        if (isJedinicaGradiva(item)) {
          label = item['en~jedinica_gradiva~javno_objavljeno']
            ? 'Odjavi'
            : 'Objavi';

          if (
            label === 'Objavi' &&
            item['en~jedinica_gradiva~status_obrade'] != 'VERIFICIRAN'
          ) {
            newTooltip = 'Jedinica gradiva nije verificirana';
          } else if (
            label === 'Objavi' &&
            item['en~jedinica_gradiva~status_dostupnosti'] != 'JAVNO'
          ) {
            newTooltip = 'Jedinica gradiva nije javno dostupna';
          }
        }

        this.setTooltip(newTooltip);
        return label;
      })
    );

    this.initDisabledObservable();
  }

  protected override initDisabledObservable() {
    this.isDisabled$ = this.itemViewProvider.item$.pipe(
      map((item) => {
        if (isJedinicaGradiva(item)) {
          if (item['en~jedinica_gradiva~javno_objavljeno']) {
            return false;
          } else {
            return !(
              item['en~jedinica_gradiva~status_dostupnosti'] == 'JAVNO' &&
              item['en~jedinica_gradiva~status_obrade'] == 'VERIFICIRAN'
            );
          }
        }
        return false;
      })
    );
  }
}
